<template>
  <div class="source-cover">
    <div class="source-cover__top">
      <div class="source-cover__top--type">
        {{ source ? source.sourceType : "" }}
      </div>

      <div
        :class="[
          'source-cover__top--title',
          `position-${sourceIndex - landingIndex + 1}`,
        ]"
        v-for="(source, sourceIndex) in sources"
        :key="source.key"
      >
        {{ source.name }}
      </div>
    </div>

    <div class="source-cover__line">
      <div class="source-cover__line--line"></div>
    </div>

    <div class="source-cover__bottom">
      <Navigator
        class="source-cover__bottom__arrows"
        :skin="'arrows'"
        :prev="prev"
        :next="next"
        :myIndex="landingIndex"
      ></Navigator>

      <div class="source-cover__bottom__slider">
        <div
          :class="[
            'source-cover__bottom__slider--item',
            { selected: index === landingIndex },
          ]"
          v-for="(s, index) in sources"
          :key="index"
        ></div>
      </div>

      <div :class="['source-cover__bottom__cta']">
        <transition-group :name="`button-${direction}`">
          <button
            :class="['source-cover__bottom__cta-button']"
            @click="goToSource()"
            :key="'main-button' + landingIndex"
          >
            {{ content.cta }}
          </button>
          <!-- <a
            v-if="source.downloadLink"
            :class="[
              'source-cover__bottom__cta-button',
              'source-cover__bottom__cta-button-secondary',
            ]"
            :key="'secondary-button' + landingIndex"
            :href="source.downloadLink"
            download
            target="blank"
            @click="clickDownload(source)"
          >
            <svgicon
              name="download"
              color="#fff"
              height="1.5rem"
              width="1.5rem"
            />
            {{ content.downloadCta }}
          </a> -->
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Navigator from "./Navigator.vue";
export default {
  name: "SourceCover",
  components: {
    Navigator,
  },
  data() {
    return {
      direction: "rtl",
      incomingAnimation: "none",
      incomingAnimationButton: "none",
      outcomingAnimationButton: "none",
      fadeAnimation: "none",
      outComingAnimation: "none",
    };
  },
  computed: {
    content() {
      return this.$t("sourceCover");
    },
    source() {
      return this.sources[this.landingIndex];
    },
    prev() {
      return this.sources[this.landingIndex - 1]
        ? this.sources[this.landingIndex - 1]
        : null;
    },
    next() {
      return this.sources[this.landingIndex + 1]
        ? this.sources[this.landingIndex + 1]
        : null;
    },

    ...mapGetters({
      landingIndex: "scroller/landingIndex",
      sources: "ui/mainSourcesRegistry",
    }),
  },
  methods: {
    async goToSource() {
      this.setMainSource(this.source.key);
      await new Promise((r) => setTimeout(r, 10));

      this.$router.push("/" + this.source.key);
    },
    clickDownload(source) {
      let contentTitle = source.downloadLink.split('/')[source.downloadLink.split('/').length - 1];
      window.digitalData.push({
        event: "click-download",
        pageEvent: {
          eventInfo: {
            eventDetail: "PDF",
            contentTitle: contentTitle,
            contentWidget: "wer",
            contentURL: source.downloadLink,
            ctaLabel: this.content.downloadCta,
          },
        },
      });
    },
    ...mapActions({
      setMainSource: "ui/setMainSource",
    }),
  },
  watch: {
    landingIndex(newV, oldV) {
      if (newV > oldV) {
        //left to right
        this.direction = "rtl";
      } else {
        // right to left
        this.direction = "ltr";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// ANIMATION CLASSES ARE IN VUE-ANIMATIONS.SCSS
$small-screens-breakpoint: 1360px;
.source-cover {
  @include cover-structure;
  @mixin cta {
    width: toRem(260);
    height: toRem(60);
    color: $gray_01;
    @include link-L;
    text-transform: uppercase;
    border-radius: toRem(6);
    background-color: $primary-yellow;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      margin-right: 1rem;
    }
  }
  @mixin cta-secondary {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }

  padding: toRem(100) 0;
  color: $ui-white;
  justify-content: flex-end;

  &__top {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 0;
    height: toRem(255); // avoid type to move

    &--type {
      @include title-H6;
      padding-left: $landing-padding-left;
      position: absolute;
      top: 5rem;
      left: 0;
      @media (max-width: $small-screens-breakpoint) {
        top: 7rem;
      }
    }
    &--title {
      position: absolute;
      right: 100vw;
      transform: translateX(100%);
      bottom: 0;
      padding-left: $landing-padding-left;
      transition: all 0.8s ease;
      @include slider-L;
      font-size: toRem(28);
      line-height: 1.4;
      white-space: nowrap;
      text-align: left;

      // Position center
      &.position-1 {
        @include slider-L;
        line-height: 0.8;
        @media (max-width: $small-screens-breakpoint) {
          font-size: toRem(130);
        }
      }

      // Position left inside viewport
      &.position-0,
      &.position--4,
      &.position--3,
      &.position--2,
      &.position--1 {
        padding-left: $landing-margin-right-left;
      }
      // Position left outside viewport
      &.position--4,
      &.position--3,
      &.position--2,
      &.position--1 {
        transform: translateX(-300px);
      }
      // Position right inside viewport
      &.position-2,
      &.position-3,
      &.position-4,
      &.position-5,
      &.position-6 {
        right: 0;
        transform: translateX(0);
        padding-right: $landing-margin-right-left;
        text-align: right;
        font-size: toRem(28);
      }
      // Position left outside viewport
      &.position-3,
      &.position-4,
      &.position-5,
      &.position-6 {
        transform: translateX(300px);
      }

      &.copy {
        @include slider-L;
        height: toRem(20);
        opacity: 0;
        padding: 0;
      }
    }
  }

  &__line {
    width: 100%;
  }

  &__bottom {
    position: relative;
    &__arrows {
      position: absolute;
      top: 0.3rem;
      left: 0;
    }
    &__slider {
      margin-left: $landing-padding-left;
      margin-bottom: toRem(20);

      height: fit-content;
      width: toRem(200);
      height: toRem(30);
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      &--item {
        width: toRem(20);
        height: toRem(3);
        margin: 0 toRem(2);
        background-color: $ui-white;
        border-radius: toRem(200);
        transition: all 0.3s ease-in-out;

        &.selected {
          background-color: $primary-yellow;
        }
      }
    }

    &__cta {
      margin-left: $landing-padding-left;
      position: relative;
      &-button {
        @include cta;
        transition: all 0.8s ease;
        position: absolute;
        top: 0;
        left: 0;
        &.button-rtl-enter {
          transform: translateX(100%);
          opacity: 0;
        }
        &.button-rtl-leave-to {
          transform: translateX(-100%);
          opacity: 0;
        }
        &.button-ltr-enter {
          transform: translateX(-100%);
          opacity: 0;
        }
        &.button-ltr-leave-to {
          transform: translateX(+100%);
          opacity: 0;
        }
        &-secondary {
          @include cta-secondary;
          left: 18rem;
        }
      }

      &.copy {
        cursor: default;
        pointer-events: none;
        opacity: 0;
        @include cta;
      }
    }
  }
}
</style>
